var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentBox"},[_c('left-box',{on:{"mode1":_vm.mode1,"mode2":_vm.mode2,"mode3":_vm.mode3,"mode4":_vm.mode4}}),_c('right-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }